export default [
  // CIARA
  {
    id: "gl-draw-line-inactive",
    type: "line",
    filter: [
      "all",
      ["==", "active", "false"],
      ["==", "$type", "LineString"],
      ["!=", "mode", "static"],
    ],
    layout: {
      "line-cap": "round",
      "line-join": "round",
    },
    paint: {
      "line-color": [
        "case",
        ["==", ["get", "user_hover"], "true"],
        "#D20C0C",
        "#3388ff",
      ],
      "line-width": 4,
      "line-opacity": 0.7,
    },
  },
  {
    id: "gl-draw-line-active",
    type: "line",
    filter: ["all", ["==", "$type", "LineString"], ["==", "active", "true"]],
    layout: {
      "line-cap": "round",
      "line-join": "round",
    },
    paint: {
      "line-color": [
        "case",
        ["==", ["get", "user_hover"], "true"],
        "#D20C0C",
        "#3388ff",
      ],
      "line-dasharray": [1, 3],
      "line-width": 4,
      "line-opacity": 0.7,
    },
  },
  {
    id: "gl-draw-line-static",
    type: "line",
    filter: ["all", ["==", "mode", "static"], ["==", "$type", "LineString"]],
    layout: {
      "line-cap": "round",
      "line-join": "round",
    },
    paint: {
      "line-color": [
        "case",
        ["==", ["get", "user_hover"], "true"],
        "#D20C0C",
        "#3388ff",
      ],
      "line-width": 4,
      "line-opacity": 0.7,
    },
  },

  // FARBA POZADIA POLYGONU
  {
    id: "gl-draw-polygon-fill-inactive",
    type: "fill",
    filter: [
      "all",
      ["==", "active", "false"],
      ["==", "$type", "Polygon"],
      ["!=", "mode", "static"],
    ],
    paint: {
      "fill-color": [
        "case",
        ["==", ["get", "user_hover"], "true"],
        "#D20C0C",
        "#3388ff",
      ],
      "fill-outline-color": [
        "case",
        ["==", ["get", "user_hover"], "true"],
        "#D20C0C",
        "#3388ff",
      ],
      "fill-opacity": 0.2,
    },
  },
  {
    id: "gl-draw-polygon-fill-active",
    type: "fill",
    filter: ["all", ["==", "active", "true"], ["==", "$type", "Polygon"]],
    paint: {
      "fill-color": [
        "case",
        ["==", ["get", "user_hover"], "true"],
        "#D20C0C",
        "#3388ff",
      ],
      "fill-outline-color": [
        "case",
        ["==", ["get", "user_hover"], "true"],
        "#D20C0C",
        "#3388ff",
      ],
      "fill-opacity": 0.2,
    },
  },
  {
    id: "gl-draw-polygon-fill-static",
    type: "fill",
    filter: ["all", ["==", "mode", "static"], ["==", "$type", "Polygon"]],
    paint: {
      "fill-color": [
        "case",
        ["==", ["get", "user_hover"], "true"],
        "#D20C0C",
        "#3388ff",
      ],
      "fill-outline-color": [
        "case",
        ["==", ["get", "user_hover"], "true"],
        "#D20C0C",
        "#3388ff",
      ],
      "fill-opacity": 0.2,
    },
  },
  // FARBA CIARY POLYGONU
  {
    id: "gl-draw-polygon-stroke-inactive",
    type: "line",
    filter: [
      "all",
      ["==", "active", "false"],
      ["==", "$type", "Polygon"],
      ["!=", "mode", "static"],
    ],
    layout: {
      "line-cap": "round",
      "line-join": "round",
    },
    paint: {
      "line-color": [
        "case",
        ["==", ["get", "user_hover"], "true"],
        "#D20C0C",
        "#3388ff",
      ],
      "line-width": 4,
      "line-opacity": 0.7,
    },
  },
  {
    id: "gl-draw-polygon-stroke-active",
    type: "line",
    filter: ["all", ["==", "active", "true"], ["==", "$type", "Polygon"]],
    layout: {
      "line-cap": "round",
      "line-join": "round",
    },
    paint: {
      "line-color": [
        "case",
        ["==", ["get", "user_hover"], "true"],
        "#D20C0C",
        "#3388ff",
      ],
      "line-dasharray": [1, 3],
      "line-width": 4,
      "line-opacity": 0.7,
    },
  },
  {
    id: "gl-draw-polygon-stroke-static",
    type: "line",
    filter: ["all", ["==", "mode", "static"], ["==", "$type", "Polygon"]],
    layout: {
      "line-cap": "round",
      "line-join": "round",
    },
    paint: {
      "line-color": "#404040",
      "line-width": 2,
    },
  },
  // KONCOVE BODY
  {
    id: "gl-draw-polygon-and-line-vertex-stroke-inactive",
    type: "circle",
    filter: [
      "all",
      ["==", "meta", "vertex"],
      ["==", "$type", "Point"],
      ["!=", "mode", "static"],
    ],
    paint: {
      "circle-radius": 8,
      "circle-color": "#fff",
    },
  },
  {
    id: "gl-draw-polygon-and-line-vertex-inactive",
    type: "circle",
    filter: [
      "all",
      ["==", "meta", "vertex"],
      ["==", "$type", "Point"],
      ["!=", "mode", "static"],
    ],
    paint: {
      "circle-radius": 5,
      "circle-color": [
        "case",
        ["==", ["get", "user_hover"], "true"],
        "#D20C0C",
        "#3388ff",
      ],
      "circle-opacity": 0.7,
    },
  },
  {
    id: "gl-draw-polygon-midpoint-stroke",
    type: "circle",
    filter: ["all", ["==", "$type", "Point"], ["==", "meta", "midpoint"]],
    paint: {
      "circle-radius": 6,
      "circle-color": "#fff",
    },
  },
  {
    id: "gl-draw-polygon-midpoint",
    type: "circle",
    filter: ["all", ["==", "$type", "Point"], ["==", "meta", "midpoint"]],
    paint: {
      "circle-radius": 3,
      "circle-color": [
        "case",
        ["==", ["get", "user_hover"], "true"],
        "#D20C0C",
        "#3388ff",
      ],
      "circle-opacity": 0.7,
    },
  },
  // point
  {
    id: "gl-draw-point-inactive",
    type: "symbol",
    filter: [
      "all",
      ["==", "active", "false"],
      ["==", "$type", "Point"],
      ["!=", "mode", "static"],
      ["!=", "meta", "vertex"],
    ],
    layout: {
      "icon-image": "marker",
      "icon-anchor": "bottom",
      "icon-offset": [0, 5],
      "icon-allow-overlap": true,
    },
    paint: {
      "icon-color": [
        "case",
        ["==", ["get", "user_hover"], "true"],
        "#D20C0C",
        "#3388ff",
      ],
      "icon-halo-color": "#ffffff",
      "icon-halo-width": 5,
      "icon-opacity": 0.7,
    },
  },
  {
    id: "gl-draw-point-active",
    type: "symbol",
    filter: [
      "all",
      ["==", "$type", "Point"],
      ["==", "active", "true"],
      ["!=", "meta", "vertex"],
    ],
    layout: {
      "icon-image": "marker",
      "icon-anchor": "bottom",
      "icon-offset": [0, 5],
      "icon-allow-overlap": true,
    },
    paint: {
      "icon-color": [
        "case",
        ["==", ["get", "user_hover"], "true"],
        "#D20C0C",
        "#3388ff",
      ],
      "icon-halo-color": "#ffffff",
      "icon-halo-width": 5,
      "icon-opacity": 0.7,
    },
  },
  {
    id: "gl-draw-point-static",
    type: "symbol",
    filter: [
      "all",
      ["==", "mode", "static"],
      ["==", "$type", "Point"],
      ["!=", "meta", "vertex"],
    ],
    layout: {
      "icon-image": "marker",
      "icon-anchor": "bottom",
      "icon-offset": [0, 5],
      "icon-allow-overlap": true,
    },
    paint: {
      "icon-color": [
        "case",
        ["==", ["get", "user_hover"], "true"],
        "#D20C0C",
        "#3388ff",
      ],
      "icon-halo-color": "#ffffff",
      "icon-halo-width": 5,
      "icon-opacity": 0.7,
    },
  },
];
